import { TableCell, TableRow, useTheme } from "@mui/material";
import type { useReactTable } from "@tanstack/react-table";
import { flexRender } from "@tanstack/react-table";

import type { IncidentTableRow } from "../types.js";

/**
 * Column header row (rendered per-section, only when section has rows)
 */
export function ColumnHeaderRow({
  table,
}: {
  table: ReturnType<typeof useReactTable<IncidentTableRow>>;
}) {
  const theme = useTheme();

  return (
    <>
      {table.getHeaderGroups().map((headerGroup) => (
        <TableRow key={headerGroup.id}>
          {headerGroup.headers.map((header) => (
            <TableCell
              key={header.id}
              sx={{
                whiteSpace: "nowrap",
                border: `1px solid ${theme.palette.grey[300]}`,
                borderBottom: `4px solid ${theme.palette.grey[300]}`,
                ...(header.id === "actions" && {
                  textAlign: "right",
                  width: "1%",
                }),
              }}
            >
              {header.isPlaceholder
                ? null
                : flexRender(
                    header.column.columnDef.header,
                    header.getContext(),
                  )}
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}
